(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this._onDocumentClick = this.onDocumentClick.bind(this);
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      if (this.elements.button && this.elements.panel) {
        this.elements.button.addEventListener('click', this.openSelector.bind(this));
        this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      }
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));
      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    connectedCallback() {
      document.addEventListener('click', this._onDocumentClick);
      this.syncDisclosureWidth();
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.syncDisclosureWidth());
      }
      if (!window.__footerLocalizationResizeBound) {
        window.__footerLocalizationResizeBound = true;
        window.addEventListener('resize', () => {
          document.querySelectorAll('localization-form').forEach((form) => {
            if (typeof form.syncDisclosureWidth === 'function') {
              form.syncDisclosureWidth();
            }
          });
        });
      }
    }

    syncDisclosureWidth() {
      const disclosure = this.querySelector('.disclosure');
      const button = this.elements.button;
      const panel = this.elements.panel;
      if (!disclosure || !button || !panel) return;

      if (window.matchMedia('(max-width: 767px)').matches) {
        disclosure.style.width = '';
        return;
      }

      disclosure.style.width = '';
      const links = panel.querySelectorAll('.disclosure__link');
      let maxWidth = 0;
      const wasHidden = panel.hasAttribute('hidden');
      const parent = disclosure.parentElement;
      const column = this.closest('.footer__localization');
      const available = Math.min(
        parent ? parent.clientWidth : Infinity,
        column ? column.clientWidth : Infinity
      );

      panel.removeAttribute('hidden');
      panel.style.visibility = 'hidden';
      panel.style.pointerEvents = 'none';
      panel.style.width = 'max-content';
      panel.style.minWidth = 'max-content';

      maxWidth = Math.max(maxWidth, button.scrollWidth || button.offsetWidth);
      links.forEach((link) => {
        maxWidth = Math.max(maxWidth, link.scrollWidth || link.offsetWidth);
      });

      panel.style.visibility = '';
      panel.style.pointerEvents = '';
      panel.style.width = '';
      panel.style.minWidth = '';
      if (wasHidden) panel.setAttribute('hidden', '');

      if (Number.isFinite(available) && available > 0) {
        maxWidth = Math.min(maxWidth, Math.max(0, available - 2));
      }
      disclosure.style.boxSizing = 'border-box';
      disclosure.style.width = maxWidth + 'px';
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocumentClick);
    }

    hidePanel() {
      if (this.elements.button && this.elements.panel) {
        this.elements.button.setAttribute('aria-expanded', 'false');
        this.elements.panel.setAttribute('hidden', true);
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      if (this.elements.button) this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      if (this.elements.input) {
        this.elements.input.value = event.currentTarget.dataset.value;
        if (form) form.submit();
      }
    }

    openSelector() {
      if (!this.elements.button || !this.elements.panel) return;
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector() {
      setTimeout(() => {
        if (this.contains(document.activeElement)) {
          return;
        }
        this.hidePanel();
      }, 0);
    }

    onDocumentClick(event) {
      if (!this.contains(event.target)) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
